var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"background",staticClass:"random-background",style:({
    filter: ((_vm.blurred ? 'blur(5px)' : null) + " " + (_vm.isInSpecialUI ? 'grayscale(0.75)' : '')),
  })})}
var staticRenderFns = []

export { render, staticRenderFns }